import React from "react";
import { InfoTextCard } from "./InfoTextCard";

export const Secondscreen = () => {
  const textObjects = [
    {
      blueText: "Qué",
      whiteText: "hacemos",
      subText: "Transparencia y eficiencia",
      mainText: [
        "Ayudamos a municipios, organizaciones públicos y empresas a simplificar su gestión, tomar mejores decisiones y ofrecer un mejor servicios a las personas.",
        <br />,
        <br />,
        "Conectamos datos, personas e infraestructuras para transformar la gestión urbana.",
      ],
    },
    {
      blueText: "Cómo",
      whiteText: "lo hacemos",
      subText: "Un ecosistema para la ciudad",
      mainText: [
        "Auditech es una plataforma integrada que cuenta con herramientas de gestión de proyectos públicos.",
        <br />,
        <br />,
        "Mediante el sistema de libros de control digitales, Auditech permite una comunicación instantanea acorde con las nuevas tecnologías. También puede crear y monitorizar puntos críticos de cualquier servicio en un sólo lugar. Permitiendo controlar eventos, registrar incidencias, y comunicar instrucciones de forma eficiente.",
      ],
    },
  ];

  return (
    <div className="flex flex-col h-[900px] justify-center items-center md:w-full">
      <div className="flex flex-col h-11/12  md:items-start items-center mt-0 mb-0 md:w-full md:mt-0 md:mb-0 md:max-w-6xl">
        {textObjects.map((x, index) => (
          <InfoTextCard
            blueText={x.blueText}
            whiteText={x.whiteText}
            subText={x.subText}
            mainText={x.mainText}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};
